// Copyright © 2021 Move Closer

import { Component } from 'vue-property-decorator'

import { Tile, TileSize, TileSizeMobile } from '../../_components/ui'

import { InnerGridWrapper } from '../_partials'
import { TeaserBoxVersion } from '../TeaserBox.contracts'
import { GridConfigType, TeaserBoxAddonsMixin } from '../TeaserBox.shared'

/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
@Component({
  name: 'TeaserBoxInnerGrid8S',
  components: { InnerGridWrapper, Tile },
  template: `
    <div class="teaser-box__inner-grid__scroll-wrap">
    <InnerGridWrapper class="teaser-box__inner-grid__scroll">
      <template v-for="item in tiles" v-if="items && items.length">
        <component :is="getComponentType(item)" v-bind="getComponentProps(item)" :key="item.key" />
      </template>
    </InnerGridWrapper>
    </div>
  `
})
export class TeaserBoxInnerGrid4S extends TeaserBoxAddonsMixin {
  public static readonly moduleVersion: TeaserBoxVersion = TeaserBoxVersion['4S']

  public gridConfig: GridConfigType = {
    defaultSize: TileSize.S,
    mobileSize: TileSizeMobile.TILE,
    tiles: { 0: TileSize.S },
    listOffset: 4,
    listType: false
  }
}
